export enum Action {
  duplicate,
  cancel,
  validate,
  print,
  printInvoice,
  toDelete,
  editInvoice,
  send,
  receive,
  refuse,
  close,
  createQuote,
  convertQuote,
  printQuote,
  cancelShipment,
  receiveFromPartner,
}

export enum InterventionStatus {
  notStarted = -1,
  inCreation = 0,
  estimate = 1,
  // itv_state_principal.quote	Estimate  /  Devis
  toProcess = 2,
  // itv_state_principal.to_process	To process  /  A traiter
  processedAndAvailable = 3,
  // itv_state_principal.done_available_customer	Processed and available  /  Traité et disponible
  paidClosed = 4,
  // itv_state_principal.payed_closed	Paid/closed  /  Payé / clôturé
  deleted = 5,
  // itv_state_principal.deleted	Deleted  /  Supprimé
  sendToRW = 6,
  // itv_state_principal.to_be_sent_in_regional_workshop	To be sent to RW  /  A envoyer en AR
  storeShortage = 7,
  // itv_state_principal.store_stock_shortage	Store shortage  /  Attente pièce
  forReceptionInRW = 8,
  // itv_state_principal.transportation_to_regional_workshop	For reception in the regional workshop  /  A réceptionner en atelier régional
  receivedForProcessingInRW = 9,
  // itv_state_principal.delivered_to_process_in_regional_workshop	Received, for processing in RW  /  Réceptionné, à traiter en AR
  closureUnderway = 10,
  // itv_state_principal.closing_in_progress	Closure underway  /  Clôture en cours
  RWShortage = 11,
  // itv_state_principal.regional_workshop_stock_shortage	RW shortage  /  Attente pièce AR
  processedToBeRedirected = 12,
  // itv_state_principal.done_to_return	Processed, to be redirected  /  Traité, à réexpédier
  forReceptionInStore = 13,
  // itv_state_principal.transportation_to_store	For reception in store  /  A réceptionner en magasin
  ogeaValidity = 41,
  // itv_state_principal.ogea_validated	OGEA validity  /  Validé OGEA
  refusedToBeRedirected = 58,
  // itv_state_principal.refused_to_return	Refused, to be redirected  /  Refusé, à réexpédier
  closed = 59,
  // itv_state_principal.closed	Closed  /  Clôturé
  refusedAndAvailable = 60,
  // itv_state_principal.refused_available_customer	Refused, available  /  Refusé,  disponible
  deliveredToPartnerFromStore = 62,
  // itv_state_principal.delivered_to_partner_from_store Intervention is sent to partner from store
  deliveredToPartnerFromRw = 63,
  // itv_state_principal.delivered_to_partner_from_rw Intervention is sent to partner from regional workshop
}
